import { render, staticRenderFns } from "./Features.vue?vue&type=template&id=64a6c1aa"
import script from "./Features.js?vue&type=script&lang=js&external"
export * from "./Features.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports